import React from 'react';
import Button from '../atoms/Button';

const TemplateCard = ({ 
  template = {},
  onUseTemplate,
  onPreview,
  className = '' 
}) => {
  const {
    name = 'Resume Template',
    image,
    category = 'Professional',
    description,
  } = template;
  
  return (
    <div 
      className={`group relative aspect-[3/4] overflow-hidden rounded-xl shadow-md transition-all duration-300 hover:shadow-xl hover:-translate-y-1 ${className}`}
    >
      {image && (
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url(${image})` }}
          role="img"
          aria-label={`${name} template preview`}
        />
      )}
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
      
      <div className="relative flex flex-col justify-end h-full p-4">
        <p className="text-white text-base font-bold leading-tight">{name}</p>
        {category && (
          <p className="text-white/80 text-sm font-medium mt-1">{category}</p>
        )}
      </div>
      
      <div className="absolute inset-0 bg-black/50 flex flex-col items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 gap-3 p-4">
        <Button 
          size="md" 
          className="w-full"
          onClick={onUseTemplate}
        >
          Use Template
        </Button>
        <Button 
          variant="ghost" 
          size="md" 
          className="w-full bg-white/20 text-white backdrop-blur-sm hover:bg-white/30"
          onClick={onPreview}
        >
          Preview
        </Button>
      </div>
    </div>
  );
};

export default TemplateCard;

